var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.022 18c-.847 0-1.45-.38-1.807-1.137-.357-.759-.27-1.463.262-2.113L6.009 8V2H4.016V0h9.968v2h-1.993v6l5.532 6.75c.532.65.619 1.354.262 2.113-.358.758-.96 1.137-1.807 1.137H2.022zm1.994-3h9.968l-3.39-4H7.406l-3.39 4zm-1.994 1h13.956L9.997 8.7V2H8.003v6.7L2.023 16z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiment);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMi4wMjIxIDE4QzEuMTc0NzggMTggMC41NzI1MjUgMTcuNjIwOCAwLjIxNTMyMyAxNi44NjI1Qy0wLjE0MTg3OSAxNi4xMDQyIC0wLjA1NDY1NTYgMTUuNCAwLjQ3Njk5NCAxNC43NUw2LjAwOTQ3IDhWMkg0LjAxNTc5VjBIMTMuOTg0MlYySDExLjk5MDVWOEwxNy41MjMgMTQuNzVDMTguMDU0NyAxNS40IDE4LjE0MTkgMTYuMTA0MiAxNy43ODQ3IDE2Ljg2MjVDMTcuNDI3NSAxNy42MjA4IDE2LjgyNTIgMTggMTUuOTc3OSAxOEgyLjAyMjFaTTQuMDE1NzkgMTVIMTMuOTg0MkwxMC41OTQ5IDExSDcuNDA1MDVMNC4wMTU3OSAxNVpNMi4wMjIxIDE2SDE1Ljk3NzlMOS45OTY4NCA4LjdWMkg4LjAwMzE2VjguN0wyLjAyMjEgMTZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+";
export { ForwardRef as ReactComponent };